import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55d6992a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "red-color" }, "*"),
  /*#__PURE__*/_createElementVNode("span", { class: "input-title" }, "图片")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "blank" }, null, -1))
const _hoisted_4 = { class: "submit-btn" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 提交 ")

import { onActivated, onMounted, reactive, ref, watch } from 'vue'
import { useRouter } from 'vue-router'
import { saveProjectPayment } from '@/apis/paymentCollection'
import SimpImageUpload from '@/components/SimpImageUpload.vue'
import ReviewPeople from '@/components/review-people/ReviewPeople.vue'
import dayjs from 'dayjs'
import { uploadFileItem } from '@/apis/base'
import { Toast } from 'vant'
import { ApproveConfig, CarboncopyConfig } from '@/apis/public/oauth'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter()
const currentDate = ref(new Date(dayjs().format('YYYY-MM-DD')))
const reimburseColumns = ref([
  { id: 1, name: '普通回款' },
  { id: 2, name: '质保金' }
])
const TypeName = {
  //  自定义 columns 结构中的字段
  id: 'id',
  text: 'name'
}
const state = reactive({
  formData: {
    project_id: null, // 项目ID
    project_name: '', // 项目名称
    type: null, // 1普通回款 2质保金
    type_name: null,
    money: null, // 回款金额
    explain: null, // 回款说明
    pics: null, // 回款图片证明
    date: null // 回款日期
  },
  contractData: { contract_money: '--', shelf_life_money: '--', receivable_money: '--' }, // 合同数据
  showTypePicker: false,
  showTimePicker: false,
  showCityPicker: false,
  money: null,
  curIndex: null
})

const formatDate = date => {
  return `${dayjs(date).format('YYYY-MM-DD')}`
}

const fileList = ref<Array<uploadFileItem>>([])
watch(fileList, (newVal, oldVal) => {
  console.log('ticket add fileList ===>', newVal)
  // data.saveData.upload_file_list = newVal
  state.formData.pics = newVal
})

const onClickItem = val => {
  state.curIndex = val
}

const onClickTime = () => {
  state.showTimePicker = true
}

const onTypeConfirm = val => {
  console.log(val)
  state.formData.type = val.id
  state.formData.type_name = val.name
  state.showTypePicker = false
}

const onTimeConfirm = val => {
  console.log(formatDate(val))
  state.formData.date = formatDate(val)
  state.showTimePicker = false
}

const onSubmit = async () => {
  console.log('formData', state.formData)
  const res = await saveProjectPayment(state.formData)
  if (res.code == 200) {
    console.log(res.data)
    Toast.success({
      message: res.msg,
      duration: 500,
      onClose: () => {
        router.back()
      }
    })
  } else {
    Toast(res.msg)
  }
}
const StaffInfo = ref({
  currentTime: '--', // 当前时间
  company_froms: {
    cf_name: '--'
  },
  name: '--'
})
const review_carbon = ref({
  review: [],
  carbon: []
})

const get_approve_config = async () => {
  let typeId = {
    type: 3
  }
  const res = await ApproveConfig(typeId)
  const res1 = await CarboncopyConfig(typeId)
  if (res.code === 200) {
    if (res.data) {
      res.data.forEach(e => {
        review_carbon.value.review.push(e.staff)
      })
    }
  }
  if (res1.code === 200) {
    if (res1.data) {
      res1.data.forEach(e => {
        review_carbon.value.carbon.push(e.staff)
      })
    }
  }
}

onMounted(() => {
  StaffInfo.value = JSON.parse(localStorage.getItem('STAFFINFO'))
  StaffInfo.value.currentTime = dayjs().format('YYYY-MM-DD HH:mm')
  let project_detail = JSON.parse(localStorage.getItem('PROJECT_DETAIL'))
  get_approve_config()
  state.contractData = {
    contract_money: project_detail.contract.money,
    shelf_life_money: project_detail.contract.shelf_life_money,
    receivable_money: project_detail.receivable_money
  }

  state.formData.project_id = router.currentRoute.value.query.project_id
  state.formData.project_name = router.currentRoute.value.query.project_name.toString()
})

return (_ctx: any,_cache: any) => {
  const _component_base_nav_bar = _resolveComponent("base-nav-bar")!
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_field = _resolveComponent("van-field")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_van_picker = _resolveComponent("van-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_common_info = _resolveComponent("common-info")!
  const _component_bottom_button = _resolveComponent("bottom-button")!
  const _component_van_form = _resolveComponent("van-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_base_nav_bar, {
      title: _ctx.$route.meta.title,
      "left-text": "返回"
    }, null, 8, ["title"]),
    _createVNode(_component_van_form, {
      class: "form",
      onSubmit: onSubmit,
      "input-align": "right"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_cell_group, null, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell, {
              title: "项目名称",
              value: _unref(state).formData.project_name
            }, null, 8, ["value"]),
            _createVNode(_component_van_field, {
              modelValue: _unref(state).contractData.contract_money,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).contractData.contract_money) = $event)),
              name: "name",
              readonly: "",
              label: "合同金额(元)",
              placeholder: "合同金额"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _unref(state).contractData.shelf_life_money,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(state).contractData.shelf_life_money) = $event)),
              name: "name",
              readonly: "",
              label: "质保金(元)",
              placeholder: "质保金"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_van_field, {
              modelValue: _unref(state).contractData.receivable_money,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(state).contractData.receivable_money) = $event)),
              name: "name",
              readonly: "",
              label: "已回款金额(元)",
              placeholder: "已回款金额"
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_van_cell_group, { title: "本次项目回款" }, {
          default: _withCtx(() => [
            _createVNode(_component_van_cell_group, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_field, {
                  modelValue: _unref(state).formData.type_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(state).formData.type_name) = $event)),
                  required: "",
                  "is-link": "",
                  readonly: "",
                  name: "type",
                  label: "回款类型",
                  placeholder: "请选择",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(state).showTypePicker = true))
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_popup, {
                  show: _unref(state).showTypePicker,
                  "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_unref(state).showTypePicker) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_picker, {
                      columns: reimburseColumns.value,
                      "columns-field-names": TypeName,
                      onConfirm: onTypeConfirm,
                      onCancel: _cache[5] || (_cache[5] = ($event: any) => (_unref(state).showTypePicker = false))
                    }, null, 8, ["columns"])
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_field, {
                  modelValue: _unref(state).formData.money,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(state).formData.money) = $event)),
                  required: "",
                  name: "userName",
                  label: "回款金额",
                  placeholder: "请输入"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_field, {
                  modelValue: _unref(state).formData.date,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(state).formData.date) = $event)),
                  readonly: "",
                  required: "",
                  "is-link": "",
                  name: "time",
                  label: "回款时间",
                  placeholder: "请选择",
                  onClick: onClickTime
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_popup, {
                  show: _unref(state).showTimePicker,
                  "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((_unref(state).showTimePicker) = $event)),
                  position: "bottom"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_datetime_picker, {
                      modelValue: currentDate.value,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((currentDate).value = $event)),
                      type: "date",
                      title: "选择日期",
                      onConfirm: onTimeConfirm,
                      onCancel: _cache[10] || (_cache[10] = ($event: any) => (_unref(state).showTimePicker = false))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["show"]),
                _createVNode(_component_van_field, {
                  "input-align": "left",
                  class: "content",
                  modelValue: _unref(state).formData.explain,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(state).formData.explain) = $event)),
                  required: "",
                  name: "content",
                  label: "回款说明",
                  type: "textarea",
                  rows: "5",
                  placeholder: "请输入"
                }, null, 8, ["modelValue"]),
                _createVNode(_component_van_cell, null, {
                  title: _withCtx(() => [
                    _hoisted_2
                  ]),
                  label: _withCtx(() => [
                    _createVNode(SimpImageUpload, {
                      isShowTitle: false,
                      modelValue: fileList.value,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((fileList).value = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_common_info, { StaffInfo: StaffInfo.value }, null, 8, ["StaffInfo"]),
        _hoisted_3,
        _createVNode(ReviewPeople, { review_carbon: review_carbon.value }, null, 8, ["review_carbon"]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_bottom_button, {
            round: "",
            block: "",
            type: "primary",
            "native-type": "submit"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})